import {Button} from '@mui/material'
import {makeOcStyles} from '@oc/styles'
import {observer} from 'mobx-react-lite'
import * as React from 'react'

const useStyles = makeOcStyles(theme => ({
    languagesButton: {
        textTransform: 'none'
    },
    fullWidth: {
        width: '100%'
    },
    flexStart: {
        textAlign: 'left',
        justifyContent: 'flex-start',
        paddingLeft: theme.spacing(2)
    }
}))

export interface DisplayLanguage {
    key: string
    nameWithoutRegion: string
    fullName: string
}

export interface LanguageListRowRenrererProps {
    language: DisplayLanguage
    style: React.CSSProperties
    onChangeHandler: (suggestion?: DisplayLanguage) => void
    selectedLanguage: DisplayLanguage
}

function _OcLanguagesListRowRenderer({
    language,
    style,
    onChangeHandler,
    selectedLanguage
}: LanguageListRowRenrererProps) {
    const {classes, cx} = useStyles()

    return (
        <Button
            style={style}
            color="secondary"
            className={cx(classes.languagesButton, classes.fullWidth, classes.flexStart)}
            variant={language.key === selectedLanguage.key ? 'contained' : void 0}
            onClick={() => onChangeHandler(language)}
            disableElevation
        >
            {language.fullName}
        </Button>
    )
}

export const OcLanguagesListRowRenderer = observer(_OcLanguagesListRowRenderer)
